;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { forwardRef } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import EntryLink from 'components/ui/Link/EntryLink';
import Icon from 'components/ui/SvgIcon';

import { getEntryLink } from 'utils/getEntryLink';

import { getAccessibleLinkLabel } from '../RichText/defaults';

import styles from './ButtonCTA.module.scss';

const iconsToTheRight = [
    'download',
    'add',
    'share',
    'subtract',
    'arrowRight',
    'chevronRight',
    'book',
    'refresh',
];

const ButtonCTA = forwardRef(
    (
        {
            className,
            text,
            link,
            assetDownloadLink,
            style,
            iconType,
            ariaLabel,
            dummy,
            ...rest
        },
        ref
    ) => {
        style ??= 'none';
        iconType ??= 'none';
        dummy ??= false;

        const entry = link || assetDownloadLink;

        const containsLink = !!entry;
        const entryHref = containsLink ? getEntryLink(entry)?.href : undefined;
        const fallbackAriaLabel =
            containsLink && !ariaLabel && !rest['aria-label']
                ? getAccessibleLinkLabel(
                      [{ value: text }],
                      entryHref,
                      entry.description || entry.title || entry.slug || entry.as
                  )
                : undefined;
        const accessibleLabel =
            rest['aria-label'] || ariaLabel || fallbackAriaLabel;
        const accessibleProps = accessibleLabel
            ? { 'aria-label': accessibleLabel }
            : {};

        const rightAlignIcon = iconsToTheRight.find(i => i === iconType);

        const styleVars = style.split('-');
        const theme = styleVars[0];
        const classes = cx(
            styles.root,
            className,
            styles[`theme-${theme}`],
            styles[`colors-${style}`],
            {
                [styles.rightAlignIcon]: !!rightAlignIcon,
            }
        );

        const renderEntry = () => {
            // return unstyled element

            if (dummy) {
                return (
                    <span className={classes} {...rest} ref={ref}>
                        {iconType !== 'none' && (
                            <Icon className={styles.icon} type={iconType} />
                        )}
                        <span>{text ?? 'button'}</span>
                    </span>
                );
            }

            if (style === 'none') {
                if (containsLink) {
                    return (
                        <EntryLink
                            className={cx(
                                styles.root,
                                className,
                                styles.unstyled
                            )}
                            entry={entry}
                            {...accessibleProps}
                            {...rest}
                            ref={ref}
                        >
                            <span>{text ?? 'button'}</span>
                        </EntryLink>
                    );
                }
                return (
                    <button
                        className={cx(styles.root, className, styles.unstyled)}
                        {...accessibleProps}
                        {...rest}
                        ref={ref}
                    >
                        <span>{text ?? 'button'}</span>
                    </button>
                );
            }

            if (!containsLink) {
                return (
                    <button
                        className={classes}
                        {...accessibleProps}
                        {...rest}
                        ref={ref}
                    >
                        {iconType !== 'none' && (
                            <Icon className={styles.icon} type={iconType} />
                        )}
                        <span>{text ?? 'button'}</span>
                    </button>
                );
            }

            return (
                <EntryLink
                    className={classes}
                    entry={entry}
                    {...accessibleProps}
                    {...rest}
                    ref={ref}
                >
                    {iconType !== 'none' && (
                        <Icon className={styles.icon} type={iconType} />
                    )}
                    <span>{text ?? 'button'}</span>
                </EntryLink>
            );
        };

        return <>{renderEntry()}</>;
    }
);

ButtonCTA.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    ariaLabel: PropTypes.string,
    link: PropTypes.object,
    assetDownloadLink: PropTypes.object,
    style: PropTypes.oneOf([
        'none',
        'filled-blue-ocean',
        'filled-blue-cream',
        'filled-cream-white',
        'filled-cream-ocean',
        'filled-custom',
        'outlined-blue-blue',
        'outlined-cream-cream',
        'inline-blue-ocean',
        'inline-blue-cream',
        'inline-cream-white',
        'makersFilled-cream-black',
        'makersFilled-gold-cream',
        'makersFilled-cream-brown',
        'makersFilled-brown-gold',
        'makersOutlined-cream-cream',
        'makersOutlined-gold-gold',
    ]),
    iconType: PropTypes.oneOf([
        'none',
        'download',
        'add',
        'explore',
        'heart',
        'location',
        'search',
        'share',
        'subtract',
        'arrowRight',
        'arrowLeft',
        'chevronRight',
        'closeSmall',
    ]),
};

export default ButtonCTA;
